import { inEmbedMode } from "../../../odc-ui";
import { titleCase } from "smart-case";

const selectionButtonType = (theme, selected) => {
  if (inEmbedMode()) {
    return selected ? "embed-selected" : "embed";
  } else {
    if (theme === "paige") {
      return selected ? "primary-paige-selected" : "primary-paige";
    } else {
      return selected ? "primary-selected" : "primary";
    }
  }
};

const friendlyCadence = (cadence) => {
  return titleCase(cadence.replaceAll("_", " "));
};

const friendlyDefaultCadence = (subscriptionPlanVariation) => {
  return friendlyCadence(subscriptionPlanVariation.default_cadence);
};

export { selectionButtonType, friendlyCadence, friendlyDefaultCadence };
